import React, { Component } from 'react';

import { AgGridReact } from "@ag-grid-community/react";
import { Loader } from 'semantic-ui-react';
import moment from 'moment';
import RestrictedSecAttachRenderer from '../../../../renderer/RestrictedSecAttachRenderer';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
// import { localStorageClient } from '../../../../../utils/localStorageClient';
// import StateSynchronizer from '../../../../../utils/StateSynchronizer';
import RestrictedSecurityApprovalStatus from '../../../../../utils/RestrictedSecurityApprovalStatus';

class RestrictedSecurityGrid extends Component {

  constructor(props) {
    super(props);

    this.state = {
      columnDefs: props.restrictedSecurityRequestGridColumns,
      defaultColDef: {
        enableCellChangeFlash: true,
        minWidth: 100
      },
      rowSelection: "multiple",
      context: { componentParent: this },
      frameworkComponents: {
        restrictedSecAttachRenderer: RestrictedSecAttachRenderer,
      },
      rowClassRules: {
        'UnProcessedReport': function(params) {
          return params.data.approvalStatus === RestrictedSecurityApprovalStatus.UNPROCESSED;
        },
      },
    };
  }

  onSelectionChanged = (event) => {
    var rowNodeArray = event.api.getSelectedNodes();
    var restrictedSecurityRequestArray = rowNodeArray.map(rowNode => rowNode.data);

    this.props.selectRestrictedSecurityRequest(restrictedSecurityRequestArray);
  }

  getRowNodeId = data => {
    return data.id;
  };

  onGridReady = params => {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;

    this.gridApi.closeToolPanel();

    // const COLUMNS_KEY = 'trade--report-grid-col-state';

    // StateSynchronizer.syncGrid(
    //   params,
    //   this.state.columnDefs,
    //   () => localStorageClient.getGridColumnState(COLUMNS_KEY),
    //   s => localStorageClient.saveGridColumnState(COLUMNS_KEY, s)
    // );
  };

  render() {
    const {
      filterRestrictedSecurityRequestArray,
      className = 'grid-wrapper',
      loadSubmittedRestrictedSecurityRequestActionStatus
    } = this.props;

    const isLoading = loadSubmittedRestrictedSecurityRequestActionStatus === ACTION_STATUS.LOGINING;
    if (loadSubmittedRestrictedSecurityRequestActionStatus === ACTION_STATUS.SUCCESS) {
      this.props.initLoadSubmittedRestrictedSecurityRequestActionStatus();
    }

    return (
      <div className={`ag-theme-balham ${className}`}>
        {isLoading ? (
            <Loader active content="Loading..." />
          ) : (
          <AgGridReact
            // properties
            columnDefs={this.state.columnDefs}
            rowData={filterRestrictedSecurityRequestArray}
            defaultColDef={this.state.defaultColDef}
            rowSelection={this.state.rowSelection}
            rowClassRules={this.state.rowClassRules}
            enableSorting={true}
            enableFilter={true}
            animateRows={true}
            deltaRowDataMode={false}
            enableColResize={true}
            resizable={true}
            sideBar={true}
            getRowNodeId={this.getRowNodeId}
            context={this.state.context}
            frameworkComponents={this.state.frameworkComponents}
            // events
            onGridReady={this.onGridReady}
            onSelectionChanged={this.onSelectionChanged}
          />
        )}
      </div>
    );
  }
}

export default RestrictedSecurityGrid;